import BusinessesIcon from 'assets/businesses-logo.svg';
import HandShakeIcon from 'assets/handshake.svg';
import LeadsIcon from 'assets/leads-icon.svg';
import TaskIcon from 'assets/task.svg';
import RoutePaths from 'routes/RoutePaths';

interface ISidebarData {
  title: string;
  path: string;
  icon: string;
}

const SidebarData: { main: ISidebarData[]; app: ISidebarData[]; quickLinks: ISidebarData[] } = {
  main: [
    {
      title: 'Dashboard',
      path: RoutePaths.Home,
      icon: '/assets/dashboard-logo.svg',
    },
    {
      title: 'Client',
      path: RoutePaths.Client,
      icon: '/assets/client.svg',
    },
    {
      title: 'Team',
      path: RoutePaths.Team,
      icon: '/assets/team.svg',
    },
    {
      title: 'Tasks',
      path: RoutePaths.Tasks,
      icon: TaskIcon,
    },
    {
      title: 'Deals',
      path: RoutePaths.Deals,
      icon: HandShakeIcon,
    },
    {
      title: 'Leads',
      path: RoutePaths.Leads,
      icon: LeadsIcon,
    },
    {
      title: 'Contacts',
      path: RoutePaths.Contacts,
      icon: '/assets/contacts-icon.svg',
    },
    {
      title: 'Businesses',
      path: RoutePaths.Businesses,
      icon: BusinessesIcon,
    },
    {
      title: 'Reports',
      path: RoutePaths.Reports,
      icon: BusinessesIcon,
    },
  ],
  app: [
    {
      title: 'Asana',
      path: RoutePaths.Asana,
      icon: '/assets/asana-logo.png',
    },
  ],
  quickLinks: [
    {
      title: 'Salesforce',
      path: `https://${process.env.REACT_APP_SALESFORCE_URI}`,
      icon: '/assets/salesforce.png',
    },

    {
      title: 'Captiv8',
      path: 'https://captiv8.io/insights/signin',
      icon: '/assets/captiv8-icon.svg',
    },
    {
      title: 'Slack',
      path: `https://slack.com/intl/en-au/signin#/signin`,
      icon: '/assets/slack-nav-icon.svg',
    },
  ],
};

export default SidebarData;
